module.exports = {"410404001":"高庄街道","410404002":"龙兴街道","410404003":"人民路街道","410404004":"龙河街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410404.json
// module id = 1556
// module chunks = 0